(ns nl.mediquest.questionnaire-frontend.component.i18n
  (:require
   [nl.mediquest.questionnaire-frontend.subs :as subs]
   [nl.mediquest.questionnaire-frontend.events :as-alias events]
   [nl.mediquest.questionnaire-frontend.translations :refer [translations]]
   [re-frame.core :as re-frame]))

(defn- focus-is-in-child?
  "Detect when the blur event was caused by focus moving to a child element"
  [^js ev]
  (.contains (.-target ev) (.-relatedTarget ev)))

(defn- close-when-unrelated-focus
  "When focus moves to a child element, ignore this blur event"
  [^js ev]
  (when-not (focus-is-in-child? ev)
    (re-frame/dispatch [::events/locale-dropdown-open? false])))

(defn- prevent-space-scroll
  "When using space to select an option, prevent its scroll action"
  [^js ev]
  (when (= "Space" (.-code ev))
    (.preventDefault ev)))

(defn- keyboard-dropdown-button-handler
  [open? ^js ev]
  (prevent-space-scroll ev)
  (case (.-code ev)
    ("Enter" "Space") (re-frame/dispatch [::events/locale-dropdown-open? (not open?)])
    "Escape" (re-frame/dispatch [::events/locale-dropdown-open? false])
    nil)) ; avoids throw

(defn- keyboard-dropdown-select-handler
  [locale ^js ev]
  (prevent-space-scroll ev)
  (case (.-code ev)
    ("Enter" "Space") (re-frame/dispatch [::events/set-locale locale])
    "Escape" (re-frame/dispatch [::events/locale-dropdown-open? false])
    nil)) ; avoids throw

(defn- set-locale-and-close
  [locale]
  (re-frame/dispatch [::events/set-locale locale])
  (re-frame/dispatch [::events/locale-dropdown-open? false]))

(defn- language-display
  [locale]
  (let [{:keys [description icon] :as _opts} @(re-frame/subscribe [::subs/language locale])]
    [:div.flex.flex-row.leading-4
     [:div.p-2.pr-0
      [:img.max-w-none.h-4 {:src icon :alt description}]]
     [:div.p-2 description]]))

(defn language-dropdown []
  (let [locales (re-frame/subscribe [::subs/locales])
        selected-locale (re-frame/subscribe [::subs/selected-locale])
        open? (re-frame/subscribe [::subs/locale-dropdown-open?])]
    [:div.pdf__hideable-item.relative
     {:data-html2canvas-ignore "data-html2canvas-ignore"
      :on-blur close-when-unrelated-focus
      :on-key-down (partial keyboard-dropdown-button-handler @open?)
      :tab-index "0"}
     [:div.cursor-pointer.rounded-md.border.hover:bg-gray-200.h-8
      {:on-click #(re-frame/dispatch [::events/locale-dropdown-open? (not @open?)])}
      [language-display @selected-locale]]
     (when @open?
       [:div.absolute.right-0.mt-1.rounded-md.bg-white.shadow-lg
        (doall
         (for [locale @locales
               :when (not= locale @selected-locale)]
          ^{:key locale}
          [:div.cursor-pointer.px-4.py-2.first:rounded-t-md.last:rounded-b-md.hover:bg-gray-200
           {:on-click #(set-locale-and-close locale)
            :on-key-down (partial keyboard-dropdown-select-handler locale)
            :tab-index "0"}
           [language-display locale]]))])]))

(defn text [k]
  (let [locale @(re-frame/subscribe [::subs/selected-locale])]
    (get-in translations [k locale])))

(defn text-or-i18n
  "Data can be resolved to text in the correct locale in 3 ways:
  * when data is a map, resolve to text with the key of the selected-locale
    (get {:nl \"Voorbeeld\"} :nl)
  * when data is a keyword, resolve from translations
  * otherwise, it's just text"
  [data]
  (cond (map? data)
        (let [locale @(re-frame/subscribe [::subs/selected-locale])]
          (get data locale))
        (keyword? data)
        [text data]
        :else
        data))

(defn url-search-param->locale
  []
  (let [search (.. js/window -location -search)]
    (.get (js/URLSearchParams. search) "lang")))

(defn init-url-param-locale
  "Initialize the locale set in the url"
  []
  (when-let [selected-locale (keyword (url-search-param->locale))]
    (re-frame/dispatch [::events/set-locale selected-locale])))
